import React from "react";
import PopupWrapper from "../../../common/PopupWrapper";
import UnitInfo from "components/common/UnitInfo";

import { unitId } from "constants/Unit";

class VPDetailPopover extends React.PureComponent {
  render() {
    const { networkId, gamUnitIds, triggerElement, units, title } = this.props;

    return (
      <PopupWrapper
        place="bottom"
        triggerType="click"
        hideArrow={false}
        triggerElement={triggerElement}
        popupElement={
          <div className="shadow border  p-4" style={{ width: "600px" }}>
            <div className="break-all font-semibold text-gray-900">
              {title || <>Units ({gamUnitIds.length})</>}
            </div>
            {gamUnitIds ? (
              <UnitInfo
                networkId={networkId}
                units={units}
                selectedItems={gamUnitIds}
                selectMetric={unitId.UNIT_ID}
              ></UnitInfo>
            ) : (
              "-"
            )}
          </div>
        }
      ></PopupWrapper>
    );
  }
}

export default VPDetailPopover;
